import React, { FC, memo } from 'react';
import {
  Card,
  CardContent,
  CircularProgress,
  colors,
  Grid,
  makeStyles,
  Typography
} from '@material-ui/core';
import { formatCurrency } from 'src/utils';
import useSellOut from 'src/hooks/use-sell-out';

const useStyles = makeStyles((theme) => ({
  root: {},
  cardContent: {
    [theme.breakpoints.up('lg')]: {
      marginRight: '20rem',
      marginLeft: '20rem'
    },
    [theme.breakpoints.down('md')]: {
      paddingX: 0
    }
  },
  totalContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column'
  }
}));

interface Props {}

const Component: FC<Props> = () => {
  const classes = useStyles();
  const { isLoading, sellOutSummary } = useSellOut();

  return (
    <Card style={{ padding: 10, marginBottom: 20 }}>
      <CardContent>
        <Grid container spacing={1} alignItems="center" justify="center">
          <Grid item xs={6} md={3}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <div className={classes.totalContainer}>
                <Typography variant="h5">Total Dealers Price</Typography>
                <Typography variant="h4" style={{ color: colors.blue[600] }}>
                  {formatCurrency(sellOutSummary?.total_dealers_price || 0)}
                </Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={6} md={3}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <div className={classes.totalContainer}>
                <Typography variant="h5">Total Retail Price</Typography>
                <Typography variant="h4" style={{ color: colors.orange[600] }}>
                  {formatCurrency(sellOutSummary?.total_retail_price || 0)}
                </Typography>
              </div>
            )}
          </Grid>
          <Grid item xs={6} md={3}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <div className={classes.totalContainer}>
                <Typography variant="h5">Gross Price</Typography>
                <Typography variant="h4" style={{ color: colors.green[600] }}>
                  {formatCurrency(sellOutSummary?.gross_price || 0)}
                </Typography>
              </div>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export const SellOutSummmary = memo(Component);
